import { availableCategories } from 'shared/models/api';

const AVAILABLE_CATEGORIES = 'AVAILABLE_CATEGORIES';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case AVAILABLE_CATEGORIES:
      return action.data && Object.keys(action.data).length
        ? action.data
        : state;
    default:
      return state;
  }
}

let loading;
export function loadAvailableCategories() {
  return dispatch => {
    if (loading) return;
    loading = true;
    availableCategories().then(data => {
      dispatch({ type: AVAILABLE_CATEGORIES, data });
      loading = false;
    });
  };
}
